/* eslint-disable no-console */
import { getItemsFromAccount, saveItemToAccount, removeItemFromAccount } from '../consumer-account/storage-actions';
import { showMyFavoritesSubmitConfirmationState } from '../dealer-contact/single-product-dealer-share-modal';

const ADD_TO_FAVORITES = 'Save<span class="sr-only"> Product</span> To Favorites';
const REMOVE_FROM_FAVORITES = 'Remove<span class="sr-only"> Product</span> From Favorites';

const getItemByProductCode = (data, id) => (
  data.find(item => id === item['product-key'])
);

const toggleFavorites = (btn, state) => {
  if (state === ADD_TO_FAVORITES) {
    btn.classList.remove('remove-from-favorites-btn');
    btn.classList.add('add-to-favorites-btn');
    btn.querySelector('.btn-label').innerHTML = ADD_TO_FAVORITES;
  } else if (REMOVE_FROM_FAVORITES) {
    btn.classList.add('remove-from-favorites-btn');
    btn.classList.remove('add-to-favorites-btn');
    btn.querySelector('.btn-label').innerHTML = REMOVE_FROM_FAVORITES;
  }
};

const updatePageFavoritesProperties = (options) => {
  // console.log('product-saving.js, updatePageFavoritesProperties');
  const {
    code,
    colorName,
    photo,
    productName,
  } = options;
  window.selectedColorVariant = {
    code,
    colorName,
    photo,
    productName,
  };
  // console.log(window.selectedColorVariant);
};

const updateProductFavoriteButtons = (options) => {
  // console.log('product-saving.js, updateProductFavoriteButtons');
  const { code } = options;
  const { isAuthenticated } = window;
  if (!isAuthenticated) {
    return;
  }
  // If logged in, check if product is already in favorites
  getItemsFromAccount('product', (data) => {
    const product = getItemByProductCode(data.products, code);
    const saveBtns = document.querySelectorAll('.save-product-btn');
    [].map.call(saveBtns, (btn) => {
      // Update instances of buttons
      if (product) {
        const productId = product['product-id'];
        btn.setAttribute('data-assetId', productId);
        toggleFavorites(btn, REMOVE_FROM_FAVORITES);
      } else {
        toggleFavorites(btn, ADD_TO_FAVORITES);
      }
    });
  });
};

const addToFavoritesEventHandlers = (btn, savedProducts) => {
  const { selectedColorVariant } = window;
  const { code } = selectedColorVariant;
  const product = getItemByProductCode(savedProducts, code);
  if (product) {
    // Add data-asset-id attribute to button
    const productId = product['product-id'];
    btn.setAttribute('data-assetId', productId);
    toggleFavorites(btn, REMOVE_FROM_FAVORITES);
  } else {
    toggleFavorites(btn, ADD_TO_FAVORITES);
  }
  btn.addEventListener('click', (event) => {
    event.stopPropagation();
    btn.classList.add('btn-disabled');
    if (btn.classList.toString().indexOf('remove-from-favorites-btn') !== -1) {
      // Remove
      const assetId = btn.getAttribute('data-assetId');
      removeItemFromAccount('product', assetId, () => {
        toggleFavorites(btn, ADD_TO_FAVORITES);
      });
    } else {
      saveItemToAccount(
        'product',
        {
          'product-key': window.selectedColorVariant.code,
          name: '',
          'tile-name': window.selectedColorVariant.productName,
          color: window.selectedColorVariant.colorName,
          'window-width': window.selectedProductHeight ? window.selectedProductHeight : 0,
          'window-height': window.selectedProductWidth ? window.selectedProductWidth : 0,
          notes: window.selectedProductNotes ? window.selectedProductNotes : '',
          'widen-url': window.selectedColorVariant.photo,
          'product-url': window.location.href,
        },
        (data) => {
          // console.log(data);
          if (data.success) {
            // Set asset id and update of all save favorite buttons for this product variant
            const saveBtns = document.querySelectorAll('.save-product-btn');
            [].map.call(saveBtns, (saveBtn) => {
              saveBtn.setAttribute('data-assetId', data['asset-id']);
              toggleFavorites(saveBtn, REMOVE_FROM_FAVORITES);
            });
            // Dealer share confirmation save-to-favorites button
            if (btn.closest('.form-submit-confirmation-with-favorites')) {
              showMyFavoritesSubmitConfirmationState();
            }
          }
        },
      );
    }
  });
};

const initProductFavoriteButtons = () => {
  // Check if product is already user's My Favorites
  const addToFavoritesBtns = document.querySelectorAll('.save-product-btn');
  const { isAuthenticated } = window;
  if (isAuthenticated) {
    // if logged in, check if product is already in favorites
    getItemsFromAccount('product', (data) => {
      [].map.call(addToFavoritesBtns, (btn) => {
        addToFavoritesEventHandlers(btn, data.products);
      });
    });
  } else {
    // Skip checking for swatches and just add event handlers
    [].map.call(addToFavoritesBtns, (btn) => {
      addToFavoritesEventHandlers(btn, []);
    });
  }
};

export {
  initProductFavoriteButtons,
  updatePageFavoritesProperties,
  updateProductFavoriteButtons,
};
/* eslint-enable no-console */
